import { getContext } from 'recompose';
import { contextTypes } from './withLassoSelectedAreaStyle.types';

export const withLassoSelectedAreaStyle = getContext(contextTypes);
